import React from "react";

const MultiRangeSlider = ({ children }) => {
  return null;
};

export { MultiRangeSlider };
